
  export const NOTIFICATIONS_RECEIVED = "NOTIFICATIONS_RECEIVED";
  export const SET_NOTIFICATION = "SET_NOTIFICATION";
  export const CREATE_NOTIFICATION = "CREATE_NOTIFICATION";
  export const SET_PROPERTY_NOTIFICATION = "SET_PROPERTY_NOTIFICATION";
  